import React from "react";

import { cn } from "./utils";

type SectionTitleProps = React.HTMLAttributes<HTMLHeadingElement> & {
  icon?: React.ReactNode;
};

export function SectionTitle({
  children,
  className,
  icon,
  ...props
}: SectionTitleProps) {
  return (
    <h2 className={cn("promo-section-title", className)} {...props}>
      {icon && <span className="promo-section-title__icon">{icon}</span>}
      <span>{children}</span>
    </h2>
  );
}
